import React from "react";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";

const THEME = createTheme({
  palette: {},
  overrides: {
    MuiPaper: {
      elevation2: {
        boxShadow: "none",
        backgroundColor: "var(--c-sole24ore-light)",
      },
    },
    MuiTable: {
      root: {
        padding: "0",
      },
    },
    MuiTableHead: {
      root: {
        backgroundColor: "var(--c-sole24ore-darkgray)",
        borderRadius: 0,
        textTransform: "uppercase",
        fontWeight: 700,
        color: "white",
      },
    },
    MuiInputBase: {
      root: {
        border: "2px solid var(--c-sole24ore-darkgray)",
        borderRadius: "1.5rem",
        padding: "0 10px",
        overflow: "hidden",
        "&&&:before": { borderBottom: "0 !important", content: "none" },
        "&&&:after": { borderBottom: "0 !important", content: "none" },
        "&:focus": { border: "0", outlineOffset: "0", boxShadow: "none" },
      },
      inputTypeSearch: {
        "&:focus": { border: "0", outlineOffset: "0", boxShadow: "none" },
      },
      input: {
        "&:focus": { border: "0", outlineOffset: "0", boxShadow: "none" },
      },
    },
    MuiInputAdornment: {
      root: {
        marginLeft: "4px",
      },
    },
    MuiTableRow: {
      root: {
        border: "none",
      },
    },
    MuiFormControl: {
      root: {
        "&&&:before": { borderBottom: "none" },
        "&&:after": { borderBottom: "none" },
      },
    },
    MuiFormControlLabel: {
      root: {
        "&$root": {
          marginLeft: 6
        }
      }
    },
    MuiCheckbox: {
      root: {
        marginLeft: 6
      },
      colorSecondary: {
        color: "var(--c-sole24ore-darkgray)",
        "&$checked": {
          color: "var(--c-sole24ore-darkgray)"
        }
      },
    },
    MuiTableCell: {
      root: {
        border: "none",
        backgroundColor: "var(--c-sole24ore-light)",
        padding: "1.2em 1.5em !important",
      },
      head: {
        backgroundColor: "transparent !important",
        border: "none",
        borderRadius: 0,
        color: "var(--c-sole24ore-light)",
      },
    },
    MuiTableSortLabel: {
      root: {
        "&:hover": { color: "var(--c-sole24ore-light)" },
      },
      active: {
        color: "var(--c-sole24ore-light) !important"
      },
      icon: {
        color: "var(--c-sole24ore-light) !important"
      }
    },
  },
});

const TableStyle = ({ children }) => {
  return (
    <div className="rounded-3xl overflow-hidden">
      <ThemeProvider theme={THEME}>{children}</ThemeProvider>
    </div>
  );
};

export default TableStyle;
